import qs from 'query-string'
import { CourseSubType } from 'libs/constants'

export const aiTermsPath = () => 'https://learn.masterclass.com/ai-terms'
export const allAccessPassPath = () => '/all-access-pass'
export const amazonPath = () =>
  'https://www.amazon.com/MasterClass-Learn-from-the-best/dp/B081QX5R8T/ref=sr_1_1?keywords=masterclass&qid=1575500772&s=mobile-apps&sr=1-1'
export const articleCategoryPath = (slug) => `/articles/categories/${slug}`
export const articlePath = (slug) => `/articles/${slug}`
export const articlesPath = () => '/articles'
export const businessPath = () => '/for-business'
export const businessAdminPath = () => '/for-business/admin'
export const caPrivacyPath = () =>
  'https://privacy.masterclass.com/policies?name=california-privacy-notice'
export const categoriesPath = () => '/categories'
export const chapterPath = (courseSlug, chapterSlug) =>
  `/classes/${courseSlug}/chapters/${chapterSlug}`
export const copyrightEmailPath = () => 'mailto:copyright@masterclass.com'
export const coursePath = (slug) => `/classes/${slug}`
export const deiPath = () => 'https://learn.masterclass.com/dei'
export const doNotSellPath = () =>
  'https://privacy.masterclass.com/policies?modal=select-subject'
export const episodePath = (seriesSlug, episodeSlug) =>
  `/series/${seriesSlug}/episodes/${episodeSlug}`
export const exclusiveGuestPassPath = () => '/exclusive-guest-pass'
export const facebookPath = () => 'https://www.facebook.com/masterclassofficial'
export const facebookSharePath = (urlToShare) =>
  encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${urlToShare}`)
export const findClassesPath = () => '/find-my-classes'
export const findClassesResultsPath = (selectedCategories) => {
  const query = qs.stringify({ categories: selectedCategories.join(',') })
  return `/find-my-classes/results?${query}`
}
export const giftPath = () => '/gift'
export const giftSubscriptionTermsPath = () =>
  'https://learn.masterclass.com/gift-terms'
export const googlePlayPath = () =>
  'https://play.google.com/store/apps/details?id=com.yanka.mc'
export const grantsPath = () => 'https://learn.masterclass.com/grants'

export const homePath = () => '/'
export const instagramPath = () => 'https://www.instagram.com/masterclass'
export const itunesPath = () => 'https://itunes.apple.com/US/app/id1273867416'
export const linkedInPath = () =>
  'https://www.linkedin.com/company/masterclassinc'
export const mainContentPath = () => '#mc-main'
export const masterclassPath = () => 'https://www.masterclass.com/'
export const newsroomPath = () => '/newsroom'
export const pinterestSharePath = (urlToShare, media, title) =>
  encodeURI(
    `https://pinterest.com/pin/create/link/?url=${urlToShare}&media=${media}&description=${title}`,
  )
export const privacyPath = () => 'https://privacy.masterclass.com'
export const privacyPolicyPath = () =>
  'https://privacy.masterclass.com/policies'
export const rokuPath = () =>
  'https://channelstore.roku.com/details/579323/masterclass-learn-new-skills'
export const securityPath = () => 'https://learn.masterclass.com/security'
export const seriesPath = (slug) => `/series/${slug}`
export const sessionsClassesPath = (slug) => `/sessions/classes/${slug}`
export const sitemapPath = () => '/sitemap'
export const sitemapArticlesPath = () => '/sitemap/articles'
export const supportEmailPath = () => 'mailto:support@masterclass.com'
export const legalNoticesEmailPath = () =>
  'mailto:legal.notices@masterclass.com'
export const termsPath = () => '/terms'
export const trendingPath = () => '/categories#trending'
export const twitterPath = () => 'https://twitter.com/masterclass'
export const twitterSharePath = (title, urlToShare) =>
  encodeURI(
    `https://twitter.com/intent/tweet?source=webclient&text=${title}&url=${urlToShare}`,
  )
export const youtubePath = () => 'https://youtube.com/c/masterclass'
export const courseOrSeriesPath = (type, courseSlug = ':courseSlug') =>
  type === CourseSubType.SERIES
    ? seriesPath(courseSlug)
    : coursePath(courseSlug)
